import log from '../../lib/logger'
import Vue from 'vue'

log.debug('Survey.js loaded')

let state = {
    surveyData: {}
}

const mutations = {
    SET_SURVEYDATA(state, payload) {
        Vue.set(state.surveyData, payload.id, payload.surveyData)
    }
}

const actions = {
    setSurveyData: ({commit, state}, payload) => {
        commit('SET_SURVEYDATA', payload)
    },
    getSurveyDataById: ({commit, state}, id) => {
        return state.surveyData[id]
    }
}

const getters = {
    getSurveyData: (state) => {
        return state.surveyData
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/survey.js